var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D1E7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_51809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 31C26.0751 31 31 26.0751 31 20C31 13.9249 26.0751 9 20 9C13.9249 9 9 13.9249 9 20C9 26.0751 13.9249 31 20 31Z",
    fill: "#F599C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5C22.6123 12.5016 25.1387 13.4334 27.1265 15.1284C29.1143 16.8233 30.4336 19.1707 30.848 21.75C31.0913 20.2508 31.0214 18.7174 30.6426 17.2466C30.2638 15.7758 29.5844 14.3994 28.6472 13.2042C27.71 12.009 26.5354 11.0209 25.1973 10.3023C23.8593 9.58366 22.3868 9.15004 20.8729 9.02877C19.3589 8.9075 17.8362 9.10122 16.4008 9.59771C14.9655 10.0942 13.6485 10.8827 12.533 11.9135C11.4175 12.9442 10.5277 14.1949 9.91964 15.5867C9.31157 16.9785 8.99844 18.4812 9.00001 20C9.00431 20.5864 9.05514 21.1716 9.15201 21.75C9.5664 19.1707 10.8857 16.8233 12.8735 15.1284C14.8613 13.4334 17.3877 12.5016 20 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 31C26.0751 31 31 26.0751 31 20C31 13.9249 26.0751 9 20 9C13.9249 9 9 13.9249 9 20C9 26.0751 13.9249 31 20 31Z",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25H21C20.7348 25 20.4804 24.8946 20.2929 24.7071C20.1054 24.5196 20 24.2652 20 24V17.5C20 17.3674 19.9473 17.2402 19.8536 17.1464C19.7598 17.0527 19.6326 17 19.5 17H18",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7451 14.5C19.6957 14.5 19.6473 14.5147 19.6062 14.5421C19.5651 14.5696 19.5331 14.6086 19.5141 14.6543C19.4952 14.7 19.4903 14.7503 19.4999 14.7988C19.5096 14.8473 19.5334 14.8918 19.5683 14.9268C19.6033 14.9617 19.6478 14.9856 19.6963 14.9952C19.7448 15.0048 19.7951 14.9999 19.8408 14.981C19.8865 14.962 19.9255 14.93 19.953 14.8889C19.9805 14.8478 19.9951 14.7994 19.9951 14.75C19.9951 14.6837 19.9688 14.6201 19.9219 14.5732C19.875 14.5263 19.8114 14.5 19.7451 14.5Z",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_51809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5a871888bd04cb0ea6ed19fb882b8002.svg";
export { ForwardRef as ReactComponent };